import React, {FC, useMemo} from 'react';
import {ALIGN, COLOR, DISPLAY, FLEX_DIRECTION, SPACE, Text, useDevice, View} from '@lookiero/aurora';
import {Logo} from '@components/atoms/Logo';

import {useIntl} from 'react-intl';
import {TEXT} from '../MaintenanceMode.definition';
import {ConfigurationApplication} from '@application/Config';
import {TradeName} from '@domain/model/Config/Configuration';

export const TextSection: FC = () => {
  const tradename = ConfigurationApplication.retrieve().tradename;
  const {screen} = useDevice();
  const isMobile = useMemo(() => !screen.L, [screen.L]);
  const {formatMessage} = useIntl();
  const isOutfittery = tradename === TradeName.OUTFITTERY;
  const isLookiero = tradename === TradeName.LOOKIERO;

  const paddingTop = isMobile ? SPACE.SPACE_16 : SPACE.SPACE_8;
  const paddingBottom = isOutfittery ? paddingTop : undefined;
  const backgroundColor = isLookiero && !isMobile ? COLOR.BG_PRIMARY_LIGHT : undefined;
  const justifyContent = isMobile ? ALIGN.START : ALIGN.CENTER;
  const paddingHorizontal = isMobile ? SPACE.SPACE_8 : SPACE.SPACE_32;

  const level = isMobile ? 3 : 2;

  return (
    <View display={DISPLAY.FLEX} style={{flex: 1}} backgroundColor={backgroundColor}>
      <View
        display={DISPLAY.FLEX}
        style={{flex: 1, height: '100%'}}
        flexDirection={FLEX_DIRECTION.COLUMN}
        justifyContent={justifyContent}
        paddingHorizontal={paddingHorizontal}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
      >
        <Logo />
        <Text heading marginTop={SPACE.SPACE_5} marginBottom={SPACE.SPACE_2} level={level}>
          {formatMessage(TEXT.TITLE)}
        </Text>
        <Text color={COLOR.TEXT_MEDIUM} level={level}>
          {formatMessage(TEXT.BODY)}
        </Text>
      </View>
    </View>
  );
};
